/**
 * The bare `/get-appointed` URL redirects to this canonical global page slug. It must match a
 * Published global onboarding page's slug for the redirect to land on a usable form (otherwise the
 * applicant sees the "not accepting submissions" state). Change this to the real global slug.
 */
export const GLOBAL_GET_APPOINTED_SLUG = 'global';
